interface Tab {
  id: string;
  label: string;
  icon: string;
  badge?: number;
}

interface Props {
  activeTab: string;
  onTabChange: (tab: string) => void;
  unreadMessages: number;
  pendingAppointments: number;
  onLogout: () => void;
  mobile?: boolean;
  onClose?: () => void;
}

const AdminSidebar = ({ activeTab, onTabChange, unreadMessages, pendingAppointments, onLogout, mobile, onClose }: Props) => {
  const tabs: Tab[] = [
    { id: 'messages',          label: 'Mensajes',           icon: 'ri-mail-line',           badge: unreadMessages },
    { id: 'appointments',      label: 'Citas',              icon: 'ri-calendar-line',       badge: pendingAppointments },
    { id: 'alquiler-requests', label: 'Alquiler',           icon: 'ri-steering-2-line' },
    { id: 'stats',             label: 'Estadísticas',       icon: 'ri-bar-chart-box-line' },
    { id: 'vehiculos',         label: 'Compra & Alquiler',  icon: 'ri-car-line' },
    { id: 'equipo',            label: 'Equipo',             icon: 'ri-team-line' },
    { id: 'servicios-precios', label: 'Servicios y Precios',icon: 'ri-price-tag-3-line' },
    { id: 'anuncio',           label: 'Anuncio',            icon: 'ri-megaphone-line' },
    { id: 'social',            label: 'Social',             icon: 'ri-video-line' },
    { id: 'facturas',          label: 'Facturas',           icon: 'ri-file-text-line' },
    { id: 'config',            label: 'Configuración',      icon: 'ri-settings-3-line' },
  ];

  return (
    <aside className="w-64 h-full bg-zinc-900 border-r border-zinc-800 flex flex-col">
      {/* Logo */}
      <div className="h-14 flex items-center justify-between px-5 border-b border-zinc-800 flex-shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 flex items-center justify-center bg-yellow-400 text-black flex-shrink-0">
            <i className="ri-tools-line text-xs" />
          </div>
          <div>
            <p className="text-white font-black text-xs uppercase tracking-widest leading-none">Kevin Admin</p>
            <p className="text-zinc-600 text-[9px] uppercase tracking-widest mt-0.5">Panel</p>
          </div>
        </div>
        {mobile && onClose && (
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-zinc-500 hover:text-white cursor-pointer">
            <i className="ri-close-line text-lg" />
          </button>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 text-left transition-all duration-200 cursor-pointer whitespace-nowrap rounded-lg ${
                isActive
                  ? 'bg-yellow-400/12 text-yellow-400'
                  : 'text-zinc-400 hover:text-white hover:bg-zinc-800/60'
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-md ${
                isActive ? 'bg-yellow-400/20' : 'bg-zinc-800'
              }`}>
                <i className={`${tab.icon} text-sm`} />
              </div>
              <span className="text-xs font-semibold flex-1 tracking-wide">{tab.label}</span>
              {tab.badge !== undefined && tab.badge > 0 && (
                <span className="min-w-5 h-5 flex items-center justify-center bg-yellow-400 text-black text-[9px] font-black rounded-full px-1">
                  {tab.badge > 99 ? '99+' : tab.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-3 border-t border-zinc-800 flex-shrink-0">
        <div className="flex items-center gap-3 px-3 py-2 mb-2">
          <div className="w-8 h-8 rounded-full bg-zinc-700 flex items-center justify-center flex-shrink-0">
            <i className="ri-user-line text-zinc-400 text-sm" />
          </div>
          <div className="min-w-0">
            <p className="text-white text-xs font-semibold truncate">Administrador</p>
            <p className="text-zinc-600 text-[10px]">Taller Kevin Alberto</p>
          </div>
        </div>
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 text-zinc-500 hover:text-red-400 hover:bg-red-500/8 transition-all cursor-pointer text-xs font-semibold whitespace-nowrap rounded-lg"
        >
          <div className="w-8 h-8 flex items-center justify-center bg-zinc-800 rounded-md flex-shrink-0">
            <i className="ri-logout-box-line text-sm" />
          </div>
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
